const translations = {
  "en": {
    "Activate it, and Ed keeps it on track for you.": "Activate it, and Ed keeps it on track for you.",
    "Adapts as your life and goals change": "Adapts as your life and goals change",
    "Ed'll pick up right where we left off and get back to tracking every holding.": "Ed'll pick up right where we left off and get back to tracking every holding.",
    "Every account you connect, Ed keeps an eye on it.": "Every account you connect, Ed keeps an eye on it.",
    "Flag risks before they land": "Flag risks before they land",
    "I turned your check-up into a plan you can act on.": "I turned your check-up into a plan you can act on.",
    "Make your plan real.": "Make your plan real.",
    "Net worth, spending and accounts in one place": "Net worth, spending and accounts in one place",
    "Notifies you only when something big changes; the rest goes into your biweekly report": "Notifies you only when something big changes; the rest goes into your biweekly report",
    "Reconnect your accounts": "Reconnect your accounts",
    "Read-only, never moves your money. Pause anytime": "Read-only, never moves your money. Pause anytime",
    "Reveal your comprehensive, long-term financial plan": "Reveal your comprehensive, long-term financial plan",
    "Track holdings, prices and returns in real time": "Track holdings, prices and returns in real time",
    "Track progress and flag risks the moment you drift off target": "Track progress and flag risks the moment you drift off target",
    "Unlock account watch.": "Unlock account watch.",
    "Watches every connected account; new ones are included automatically": "Watches every connected account; new ones are included automatically",
    "Your plan is ready. Unlock full access.": "Your plan is ready. Unlock full access."
  },
  "zh-tw": {
    "Activate it, and Ed keeps it on track for you.": "啟用後，Ed 會為你持續追蹤進度。",
    "Adapts as your life and goals change": "隨著你的生活與目標改變而調整",
    "Ed'll pick up right where we left off and get back to tracking every holding.": "Ed 將接續先前的進度，恢復追蹤每檔持倉。",
    "Every account you connect, Ed keeps an eye on it.": "你連接的每個帳戶，Ed 都會持續盯著。",
    "Flag risks before they land": "在風險發生前預先警示",
    "I turned your check-up into a plan you can act on.": "我把你的健檢結果變成了一份你可以執行的計畫。",
    "Make your plan real.": "實現你的計畫。",
    "Net worth, spending and accounts in one place": "淨資產、支出與帳戶，一處掌握",
    "Notifies you only when something big changes; the rest goes into your biweekly report": "只有重要變化才通知你，其餘進雙週報告",
    "Reconnect your accounts": "重新連結你的帳戶",
    "Read-only, never moves your money. Pause anytime": "唯讀不動你的錢，隨時暫停",
    "Reveal your comprehensive, long-term financial plan": "呈現你全面的長期財務規劃",
    "Track holdings, prices and returns in real time": "即時追蹤持倉、價格與報酬",
    "Track progress and flag risks the moment you drift off target": "追蹤進度，一偏離目標就立即標示風險",
    "Unlock account watch.": "解鎖帳戶追蹤。",
    "Watches every connected account; new ones are included automatically": "追蹤你連接的每個帳戶，新加入的自動包含",
    "Your plan is ready. Unlock full access.": "你的計畫已就緒。解鎖完整權限。"
  }
};

export default translations;
